import { useState } from "react";

const TABS = ["全部", "事件查询", "人物专题"];

const HOT_WORDS = [
  { tag: "爆", text: "红毯风波" },
  { tag: "新", text: "录音门后续" },
  { tag: "热", text: "解约传闻" },
  { tag: "升", text: "新剧路透" },
];

export default function SearchLookup() {
  const [tab, setTab] = useState(0);
  const [kw, setKw] = useState("");

  return (
    <section id="search" className="border-y border-[#e5ded2] bg-white/70">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-red-700/10 px-3 py-1 text-xs font-semibold text-red-700">
            <i className="ri-search-2-line w-4 h-4 flex items-center justify-center"></i>
            网曝网站内查找 · 一搜即得
          </span>
          <h2 className="font-serif-sc mt-4 text-balance text-2xl font-black text-stone-900 md:text-3xl">
            你想吃哪段瓜？关键词搜索查找一下
          </h2>
          <p className="mt-2 max-w-2xl text-sm text-stone-500">
            支持事件查询、人物专题与站内查找，输入事件、人物或任意关键词，快速定位目标内容。
          </p>
        </div>

        {/* search box */}
        <form
          className="mx-auto mt-7 flex max-w-3xl flex-col items-stretch gap-2 sm:flex-row sm:items-center sm:gap-1 sm:rounded-full sm:border sm:border-stone-200 sm:bg-white sm:p-1.5"
          onSubmit={(e) => e.preventDefault()}
        >
          <div className="flex shrink-0 items-center gap-0.5 rounded-full bg-stone-100 px-1 py-1 sm:bg-transparent">
            {TABS.map((t, i) => (
              <button
                key={t}
                type="button"
                onClick={() => setTab(i)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  tab === i
                    ? "bg-red-700 text-[#f7f3eb]"
                    : "text-stone-600 hover:text-red-700"
                }`}
              >
                {t}
              </button>
            ))}
          </div>

          <div className="relative flex flex-1 items-center">
            <i className="ri-search-line absolute left-4 w-4 h-4 flex items-center justify-center text-stone-400"></i>
            <input
              type="text"
              name="keyword"
              value={kw}
              onChange={(e) => setKw(e.target.value)}
              placeholder="输入事件名、人物名或网曝网关键词…"
              className="w-full rounded-full border border-stone-200 bg-white py-3 pl-11 pr-4 text-sm text-stone-800 placeholder:text-stone-400 focus:border-red-700 focus:outline-none focus:ring-2 focus:ring-red-700/10 sm:border-0"
            />
          </div>

          <button
            type="submit"
            className="whitespace-nowrap rounded-full bg-red-700 px-6 py-3 text-sm font-semibold text-[#f7f3eb] transition-colors hover:bg-red-800"
          >
            搜 索
          </button>
        </form>

        {/* quick keywords */}
        <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
          <span className="text-xs text-stone-400">网曝网关键词库·站内热词：</span>
          {HOT_WORDS.map((w) => (
            <a
              key={w.text}
              href="#events"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-stone-200 bg-white px-3 py-1.5 text-xs text-stone-600 transition-colors hover:border-red-700 hover:text-red-700"
            >
              <span className="rounded-sm bg-stone-100 px-1 text-[10px] font-bold text-red-700">{w.tag}</span>
              {w.text}
            </a>
          ))}
          <a
            href="#events"
            className="inline-flex items-center gap-1 whitespace-nowrap px-2 py-1.5 text-xs font-medium text-red-700 hover:text-red-800"
          >
            查看更多
            <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}